module.exports = __webpack_public_path__ + "static/media/Rates.b2e046db.svg";